import { render, staticRenderFns } from "./UserAccessEditor.vue?vue&type=template&id=6fdcfa6c"
import script from "./UserAccessEditor.vue?vue&type=script&lang=js"
export * from "./UserAccessEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports